import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { type ColumnDef } from '@tanstack/react-table'
import { PlusIcon } from 'lucide-react'
import { useMemo } from 'react'

import { Cell, DataTable, useDataTable } from '@/components/block/data-table'
import { Page } from '@/components/layout/page'
import { Button } from '@/components/ui/button'
import { CardExtendTable } from '@/components/ui/card-extend'

import { OutletDto, outletMasterApi } from '@/features/outlet'

export const Route = createFileRoute('/_app/settings/outlet/')({
  component: Component,
})

function Component() {
  return (
    <Page>
      <Page.Breadcrumbs />
      <CardExtendTable
        title='Daftar Outlet'
        action={
          <Button asChild>
            <Link from={Route.fullPath} to='/settings/outlet/create'>
              <PlusIcon /> Tambah Outlet
            </Link>
          </Button>
        }
      >
        <OutletTable />
      </CardExtendTable>
    </Page>
  )
}

function OutletTable() {
  const { data, isLoading } = useQuery({ ...outletMasterApi.list.query({ params: {} }) })

  const columns = useMemo(() => getColumns(), [])
  const table = useDataTable({
    columns,
    isLoading,
    data: data?.data.outlets ?? [],
  })

  return (
    <DataTable.Root table={table}>
      <DataTable.Table />
      <DataTable.Pagination />
    </DataTable.Root>
  )
}

function getColumns(): ColumnDef<OutletDto>[] {
  return [
    {
      accessorKey: 'name',
      header: 'Outlet',
      minSize: 180,
      cell: ({ row }) => (
        <Cell.Link to='/settings/outlet/$id' from={Route.fullPath} params={{ id: row.original.id }}>
          {row.original.name}
        </Cell.Link>
      ),
    },
    {
      accessorKey: 'type',
      header: 'Jenis Outlet',
      cell: ({ row }) => <Cell.Text text={row.original.type.toUpperCase()} />,
    },
    {
      accessorKey: 'email',
      header: () => 'Email',
      cell: ({ row }) => <Cell.Text text={row.original.email} />,
    },
    {
      accessorKey: 'phone',
      header: () => 'No. Telepon',
      cell: ({ row }) => <Cell.Text text={row.original.phone} />,
    },
    {
      accessorKey: 'address',
      header: () => 'Alamat',
      cell: ({ row }) => <Cell.Text text={row.original.address} />,
    },
    {
      accessorKey: 'updatedAt',
      header: () => 'Updated At',
      cell: ({ row }) => <Cell.Date date={row.original.updatedAt} />,
    },
    {
      accessorKey: 'createdAt',
      header: () => 'Created At',
      cell: ({ row }) => <Cell.Date date={row.original.createdAt} />,
    },
  ]
}
